import { Injectable } from '@angular/core';
import { SignInMethodRedirect, User, UserManager, logger } from '@gls-group/gls-user-manager';
import { withLocale as UserManagerWithLocale } from '@gls-group/gls-user-manager/dist/cjs/oidc-default-settings';
import { ConfigService } from './config.service';
import { QueryParams } from './QueryParams';
import { Log } from 'oidc-client';


const KC_LOCALE_PARAM = 'ui_locales';
const POST_LOGOUT_PARAM = 'postLogoutRedirectURL';
const LOG_DEBUG = 'logDebug';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  clientId: string;
  scope: string;
  authority: string;
  redirectURI: string;
  postLogoutURI: string;
  productLogoutURI: string;
  productEntryPoint: string;
  forwardQueryParams: string[];
  extraQueryParams: string[];
  postLogoutRedirectURL: string;

  private _userManager: UserManager;

  constructor(private configService: ConfigService, private window: Window) {
    this.clientId = this.configService.get<string>('client_id');
    this.scope = this.configService.get<string>('scope');
    this.authority = this.configService.get<string>('authority');
    this.redirectURI = this.configService.get<string>('redirect_uri');
    this.productLogoutURI = this.configService.get<string>('product_logout_uri')

    const queryParams = new URLSearchParams(this.window.location.search);
    this.postLogoutRedirectURL = queryParams.get(POST_LOGOUT_PARAM) || "";

    this.productEntryPoint = this.configService.get<string>('product_entrypoint');
    this.forwardQueryParams = this.configService.get<string[]>('query_params');
    this.extraQueryParams = this.configService.get<string[]>('extra_query_params');

    this.postLogoutURI = `${this.window.location.origin}/`;
    const logDebug = queryParams.get(LOG_DEBUG) || false;
    if(logDebug){
      logger(console, Log.DEBUG );
    }
    this._userManager = this._setupUserManager();
  }

  private _setupUserManager() {
    const redirectURL = this._appendForwardParameters();

    const signInMethod = new SignInMethodRedirect(
      redirectURL.toString(),
      this.postLogoutURI
    );

    const locale = redirectURL.searchParams.get('locale');

    if (locale) {
      UserManagerWithLocale(locale);
    }

    const extraQueryParams = this._configureExtraQueryParams().params;

    return new UserManager(
      this.clientId,
      this.scope,
      signInMethod,
      this.authority,
      extraQueryParams,
      localStorage
    );
  }


  createProductRedirectUrl (user: User): URL {
    const queryParams = new URLSearchParams(this.window.location.search);
    const productEntryPointURL = new URL(this.productEntryPoint);

    for (const forwardQueryParam of this.forwardQueryParams) {
      const value = queryParams.get(forwardQueryParam);

      if(value) {
        productEntryPointURL.searchParams.append(forwardQueryParam, value);
      }
    }

    productEntryPointURL.searchParams.append('token', user.access_token);

    return productEntryPointURL;
  }

  private _appendForwardParameters(): URL {
    const queryParams = new URLSearchParams(this.window.location.search);
    const forwardQueryParams = this.configService.get<string[]>('query_params');

    const redirectURL = new URL(this.redirectURI);

    for (const forwardQueryParam of forwardQueryParams) {
      const queryParamValue = queryParams.get(forwardQueryParam);
      if (queryParamValue !== null) {
        redirectURL.searchParams.append(forwardQueryParam, queryParamValue);
      }
    }

    return redirectURL;
  }

  private _configureExtraQueryParams(): Record<string,any> {
    const queryParams = new URLSearchParams(this.window.location.search);
    const extraQueryParamsList = this.configService.get<string[]>('extra_query_params');

    const extraQueryParams = new QueryParams();

    for (const extraQueryParam of extraQueryParamsList) {

      let queryParam = extraQueryParam;
      if(extraQueryParam === 'ui_locales') {
        queryParam = 'locale';
      }

      const queryParamValue = queryParams.get(queryParam);
      if (queryParamValue !== null) {
        extraQueryParams.addParams({[extraQueryParam]: queryParamValue});
      }
    }

    return extraQueryParams;
  }


  get userManager() {
    return this._userManager;
  }
}
